import {styled} from "styled-components";

export const FontIcon = styled.img`
  @media (max-width: 420px) {
    display: none;
  }
`;